export default "__VITE_ASSET__DHPTXKwc__"